export default {"src":"/_next/static/media/car_traffic_3.99caf29e.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};